import { gsap } from 'gsap';
import Splide from '@splidejs/splide';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { InitMap } from './InitMap';
import { GenericHandler } from './GenericPageHandler';
import { imagesLoaded } from 'imagesloaded';

export class CustomNewPageHandler extends GenericHandler {
    constructor(id) {
    	super(id);
    }

    init() {

		if (jQuery('._df_thumb').length)
			gsap.set('._df_thumb',  {opacity: 0, y: 50} )

		if (jQuery('main')[0].id == "custom-work-new")
		{
			// lightbox.option({
			// 	'resizeDuration': 200,
			// 	'wrapAround': true
			// })
			const lightbox = GLightbox({
				touchNavigation: true,
				autoplayVideos: true,
				openEffect: 'fade',
				closeEffect: 'fade'
			});
		}
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		if (jQuery('main')[0].id == "lookbooks" || jQuery('main')[0].id == "lookbooks-en")
		{
			gsap.timeline()
			.fromTo('.page-title, .subheading, .custom-container .custom-content', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
			.set('._df_thumb',  {opacity: 1, y: 0}, "-=0.8")

		}
		else if (jQuery('main')[0].id == "custom-work")
		{
			gsap.timeline()
			.fromTo('.page-title, .subheading, .custom-container .custom-text', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
			.fromTo('.custom-work-item', {autoAlpha: 0}, {autoAlpha: 1, duration: 0.8, stagger: 0.05, ease: "power2.inout"}, "-=0.4")
			.fromTo('.custom-container h2', {x: -20}, {x: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.4")
			// .to('.bwg_container', {autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.8")

		}
		else if (jQuery('main')[0].id == "custom-work-new")
		{
			
			gsap.timeline()
			.fromTo('.page-title, .subheading, .custom-container .custom-text', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
			.fromTo('.custom-work-item', {autoAlpha: 0}, {autoAlpha: 1, duration: 0.8, stagger: 0.05, ease: "power2.inout"}, "-=0.4")
			.fromTo('.custom-container h2', {x: -20}, {x: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.4")
			// .to('.bwg_container', {autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.8")

		}

		else if (jQuery('main')[0].id == "blog")
		{
			gsap.timeline()
			.fromTo('.page-title, .subheading, .custom-content, .entry-meta', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
			.fromTo('article', {autoAlpha: 0}, {autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.4")
		}

		else if (jQuery('main')[0].id == "single-post")
		{
			gsap.timeline()
			.fromTo('.page-title, article > header .entry-meta', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
			.fromTo('.custom-content', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.2")
		}

		else 
		{
			gsap.timeline()
			.fromTo('.page-title, .subheading, .custom-content', {y: 50}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
			.fromTo('.custom-container h3', {x: -20}, {x: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"}, "-=0.8")
		}

	}
}